import { useMemo } from "react";

import { atom, useAtom } from "jotai";

const pageTitleAtom = atom("Northbeam");

export const usePageTitle = () => {
  const [_pageTitle, setPageTitle] = useAtom(pageTitleAtom);
  const pageTitle = useMemo(() => {
    let title = "Northbeam";
    if (_pageTitle && _pageTitle !== "Northbeam") {
      title = `${_pageTitle} | Northbeam`;
    }
    document.title = title;
    return _pageTitle;
  }, [_pageTitle]);

  return [pageTitle, setPageTitle] as const;
};
